module.exports = __webpack_public_path__ + "static/img/075_TO8_1706_og.0f43cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/075_TO8_1706_og.jpg
// module id = qGqB
// module chunks = 0